<template>
  <div>
    <div>
      <el-row type="flex">
        <el-col :span="18">
          <el-row type="flex" :gutter="4">
            <el-col :span="5">
              <el-select
                  v-model="filterStatusPackage"
                  placeholder="Trạng thái"
                  @change="handleChangeFilterStatus"
              >
                <el-option
                    v-for="(item, index) in packageDelActive"
                    :key="index"
                    :label="item.label"
                    :value="item.value"/>
              </el-select>
            </el-col>
          </el-row>
        </el-col>

        <el-col :span="6">
          <el-row type="flex" :gutter="4" justify="end">
            <el-col :span="9">
              <el-button
                  type="success"
                  size="medium"
                  icon="el-icon-plus"
                  @click="handleOpenCreateDialog"
              >
                Thêm mới
              </el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>

    <div style="margin-top: 20px; margin-bottom: 18px">
      <slot/>
    </div>

    <!--  Tạo gói mới  -->
    <DefaultLayoutDialog
        title="Thêm một gói mới"
        width="30%"
        :isOpen="visibleDialog.createForm"
        @update:isOpen="setCreateForm"
    >
      <FormCreateDialogPackage
          @closeDialogCreate="setCreateForm"
          ref="FormCreateDialogPackage"
      />
    </DefaultLayoutDialog>
  </div>
</template>

<script>
import {packageDelActive} from "@/constant/listCommon";
import DefaultLayoutDialog from "@/components/FinanceVer2/managePackages/components/dialog/DefaultLayoutDialog.vue";
import FormCreateDialogPackage from "@/components/FinanceVer2/managePackages/components/dialog/elements/FormCreateDialogPackage.vue";

export default {
  components: {
    DefaultLayoutDialog,
    FormCreateDialogPackage,
  },
  data() {
    return {
      filterStatusPackage: true,
      packageDelActive,
      visibleDialog: {
        createForm: false,
      },
    }
  },
  created() {
    this.fetchDataPackages(this.filterStatusPackage);
  },
  methods: {
    handleChangeFilterStatus(value) {
      this.fetchDataPackages(value);
    },

    fetchDataPackages(boolean) {
      this.$store.dispatch("packageStore/fetchDataPackages", boolean);
    },

    setCreateForm(isOpen) {
      this.visibleDialog.createForm = isOpen;
      this.filterStatusPackage = true;
    },

    handleOpenCreateDialog() {
      this.visibleDialog.createForm = true;
      this.$refs.FormCreateDialogPackage.resetForm();
    },
  }
}
</script>

<style lang="scss" scoped>

</style>